
import Game from '../../../Game';
import { IGameState } from '../../../State/Game/IGameState';
import GameObject, { GameObjectEvent } from '../../../GameObject/GameObject';
import AnimationComponent from '../../../Component/Animation';
import ButtonComponent from '../../../Component/UI/ButtonComponent';
import { applyDefaultButtonAnimation } from '../../../System/UI/UIHelper';
import Renderable from '../../../Component/Renderable';
import { UIActions } from '../../../State/UI/UIActions';
import StateComponent from '../../../Component/State';
import { PopupID } from '../../../State/UI/PopupID';
import { IAPStateHelper } from 'State/Player/IAP/IAPStateHelper';
import { EventType } from 'Utility/Helpers/Events/EventType';
import { createEventOfferTimer } from 'State/Events/EventHelper';
import { EVENT_OFFERS } from 'Constants/Shop';
import Timer from 'System/Timer/Timers/Timer';
import { EventOfferButtonLayout } from 'Layouts/WorldHud/EventOfferButtonLayout';
import TextComponent from 'Component/Render/Text';
import TransformComponent from 'Component/Transform';
import Element, { IElementData } from 'Prototype/UI/Element';
import CleanupManager from 'Utility/CleanupManager';
import SpriteComponent from 'Component/Render/Sprite';

export class EventOfferButton extends Element {
    private layout: EventOfferButtonLayout;
    private _isVisible: boolean = undefined;
    private cleanupManager: CleanupManager;

    /**
     * If true, ignore input; for fixing click-spam issues
     */
    private _throttleClick: boolean = false;

    private timer: Timer;
    private eventType: EventType;

    public onCreate(params: IElementData & {
        eventType: EventType,
    }): void {
        super.onCreate(params);
        this.cleanupManager = new CleanupManager();
        this.eventType = params.eventType;
        const offer = EVENT_OFFERS[this.eventType];
        this.addComponent(AnimationComponent, params);
        
        this.layout = new EventOfferButtonLayout();
        const root = this.poofGameObject(this.layout.root);
        const icon = this.poofGameObject(this.layout.icon);
        const timerText = this.poofGameObject(this.layout.timerText);
        this.addChild(root);

        const timerTextComponent = timerText.getComponent(TextComponent);
        timerTextComponent.style = Game.style.getStyle("sundayOffer.timer");
        this.timer = createEventOfferTimer(Game.store.getState(), this.eventType, timerTextComponent, {
            onComplete: (state: IGameState) => {
                this.handleStateChanged(state);
            }
        });

        root.addComponent(ButtonComponent, {
            toggleable: true,
        });
        root.addComponent(TransformComponent, params)

        icon.getComponent(SpriteComponent).texture = offer.buttonCacheKey;

        this.addComponent(StateComponent, {
            handleStateChanged: this.handleStateChanged
        });
    }

    private readonly handleStateChanged = (state: IGameState) => {
        const offerAvailable = IAPStateHelper.isEventOfferAvailable(state);
        
        if (this._isVisible === offerAvailable) {
            return;
        }

        this._isVisible = offerAvailable;

        if (this._isVisible) {
            this.show();
        } else {
            this.hide();
        }
    }

    private poofGameObject(obj: unknown): GameObject {
        return obj as GameObject;
    }

    private readonly onSelect = (): void => {
        if (this._throttleClick) return;
        this._throttleClick = true;
        UIActions.showPopup(PopupID.EVENT_OFFER, {
            eventType: this.eventType
        });
        setTimeout(() => (this ? (this._throttleClick = false) : void 0), 700);
    }

    public show(): void {
        this.timer.start();
        const root: GameObject = this.poofGameObject(this.layout.root);
        root.getComponent(Renderable).visible = true;
        root.on(GameObjectEvent.SELECTED, this.onSelect);
        const buttonCleanup = applyDefaultButtonAnimation(root);

        this.cleanupManager.add(() => {
            this.timer.stop();
            buttonCleanup();
            root.off(GameObjectEvent.SELECTED, this.onSelect)
        });
    }

    public hide(): void {
        this.cleanupManager.cleanUpAll();
        const root: GameObject = this.poofGameObject(this.layout.root);
        root.getComponent(Renderable).visible = false;
    }

    public destroy(): void {
        const root = this.poofGameObject(this.layout.root);
        root.off(GameObjectEvent.SELECTED, this.onSelect);
        super.destroy();
    }
}
